exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#signature[data-v-b358cd74] {\n    border: 2px solid #0B96AE;\n    border-radius: 4px;\n}\n", ""]);

// exports
